import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('old.components.Panel', {
    hasMore: 'First {count} items are shown.{br}Please type in what you are looking for',
});
